import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData,
  type AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError,
  type AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse,
  addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost,
} from '../../generated';

export type AddUserToOrganizationMutationVariables =
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData['path'];

export type AddUserToOrganizationMutation =
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse;

export const useAddUserToOrganizationMutation = <
  TError = AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<AddUserToOrganizationMutation, TError, AddUserToOrganizationMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<AddUserToOrganizationMutation, TError, AddUserToOrganizationMutationVariables, TContext>({
    mutationKey: ['AddUserToOrganization'],
    mutationFn: async ({ organization_id, email_address }: AddUserToOrganizationMutationVariables) => {
      const { data } = await addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost({
        path: { organization_id, email_address },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useAddUserToOrganizationMutation.fetcher = (
  { organization_id, email_address }: AddUserToOrganizationMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost({
      path: { organization_id, email_address },
      throwOnError: true,
    });
    return data;
  };
};
